import React, { Component } from "react";

// Styles
import "./WelcomeContinued.scss";

// Components
import Button from "components/Button";

// Images
import CodeBerry from "../../static/img/CodeBerry.svg";

import { BackgroundMusicStart, ButtonSound } from "../../utility/sounds";
import { levelsMap } from "utility/levelsData";
import { GAME_TIME } from "utility/Timer";
import { storage } from "services/config/storage";
import { inverseTransform } from "utility/helperFunctions";
import { secondTutorialLevel } from "utility/constants";
import { GC } from "services/config/gamecentreService";

class WelcomeContinued extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.gameDetails = storage.get.gameDetails();
  }

  componentDidMount() {
    localStorage.removeItem("is_reloaded");
    document.querySelector("body").style.overflow = "hidden";
    localStorage.getItem("wrongMoves") && localStorage.removeItem("wrongMoves");
    localStorage.getItem("moves1") && localStorage.removeItem("moves1");
    localStorage.getItem("moves2") && localStorage.removeItem("moves2");
    localStorage.getItem("moves3") && localStorage.removeItem("moves3");
    localStorage.getItem("undos") && localStorage.removeItem("undos");
    localStorage.getItem("pressedPlayButtonWithEmptyLoops") &&
      localStorage.removeItem("pressedPlayButtonWithEmptyLoops");
  }

  componentWillUnmount() {
    document.querySelector("body").style.overflow = "auto";
  }

  initFullScreenMode() {
    let elem = document.querySelector(".App");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  startButtonClickHandler() {
    ButtonSound()
    if (window.screen.width < 1024) {
      // this.initFullScreenMode()
    }
    const gameData = storage.get.levelData();
    let transformGameData = null;
    if (gameData && gameData?.levelData?.length) {
      transformGameData = inverseTransform(gameData);
    }
    const { level, stats, seconds } = transformGameData ?? '';
    if (gameData?.levelData?.length === 0 || !gameData) {
      GC.createGameMasterSession();
      this.props.history.replace("/tutorial1");
    } else if (level >= 1) {
      const nextLevel = level + 1;
      this.props.history.replace({
        pathname: nextLevel === secondTutorialLevel ? "/tutorial2" : "level",
        level: nextLevel,
        seconds: seconds,
        total: levelsMap.length,
        stats: stats,
      });
    }
    // this.props.history.push('/level')
    localStorage.setItem("playMusic", JSON.stringify(false))
  }

  render() {
    return (
      <div className="start-page2">
        <div className="start-page2__main-container">
          <div className="start-page__text-start">
            <div className="logo-img">
              {
                this.gameDetails?.mediaUrl ?
                  <img className="logo-img-codebetty" src={this.gameDetails.mediaUrl} alt="CodeBerry" /> :
                  <h4 className="logo"><span>Bot</span>Berry</h4>
              }
              {
                this.gameDetails?.organizationName &&
                <p style={{ position: 'relative', fontSize: '14px', fontWeight: '200' }}>
                  Powered by <span style={{ fontWeight: '700' }}>{this.gameDetails.organizationName}</span>
                </p>
              }
              {/* <h4 className="logo">
                <span>Bot</span>Berry
              </h4> */}
              {/* <img className="logo-img-codebetty" src={CodeBerry} alt="CodeBerry" /> */}
            </div>
            <div className="instructions">
              <span role="img" aria-label="target">
                🎯
              </span>{" "}
              Instructions
            </div>
            <p className="instruction-text">
              Make the bot move using the commands, light all the green tiles and perform any other task that’s laid out on it’s path. Code your way to glory!
            </p>
            <div className="start-page__bottom-container">
              <div className="level-duration">
                <div className="start-page__bottom-container--stats-container">
                  <div className="stat">
                    <p className="stat__title">
                      Levels
                    </p>
                    <p className="stat__value">
                      {levelsMap.length}
                    </p>
                  </div>
                  <div className="stat__divider">

                  </div>
                  <div className="stat">
                    <p className="stat__title">
                      Time
                    </p>
                    <p className="stat__value">
                      {Math.floor(GAME_TIME / 60)}<span className="stat__value--small">min</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="btn-wrapper2 btn-wrapper">
              <Button
                className="play-btn tab-for-next2 tab-for-next"
                onClick={() => this.startButtonClickHandler()}
              >
                START GAME
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default WelcomeContinued;
